import { getExams } from '../../config';
import { firestore, auth } from './config';
import { createLogger } from "../utils/logger";

let client = null;
const logger = createLogger(true, 'Client');


export const getClientExams = async () => {
    try {
        // For activation flow, we need to access exams without authentication
        const currentUser = auth().currentUser;
        logger.log('Getting client exams, current user:', currentUser ? currentUser.uid : 'No user');
        
        logger.log('Fetching exams from Firestore...');
        try {
            const examsSnapshot = await firestore()
                .collection('exams')
                .get();
                
            const exams = [];
            examsSnapshot.forEach(doc => {
                exams.push({
                    display_title: doc.data().display_title,
                    title: doc.data().title,
                    key: doc.data().key,
                    appCollectionName: doc.data().app_collection_name
                });
            });
            
            logger.log('Exams loaded:', exams.length, 'exams');
            return exams;
        } catch (firestoreError) {
            logger.error('Firestore error:', firestoreError);
            
            // If it's an auth error, try to provide a fallback or better error message
            if (firestoreError.code === 'permission-denied') {
                throw new Error('Access denied. Please check your authentication or contact support.');
            } else if (firestoreError.code === 'unavailable') {
                throw new Error('Service temporarily unavailable. Please try again later.');
            } else {
                throw new Error(`Failed to load exams: ${firestoreError.message}`);
            }
        }
    } catch (error) {
        logger.error('Error getting client exams:', error);
        throw error;
    }
}; 

export const getClientConfig = async () => {
    try {
        // For activation flow, we need to access config without authentication
        // This should be a public collection or we need to handle the auth state
        const currentUser = auth().currentUser;
        logger.log('Current user:', currentUser ? currentUser.uid : 'No user');
        
        if (!client) {
            logger.log('Fetching client config from Firestore...');
            try {
                const configSnapshot = await firestore()
                    .collection('config')
                    .doc('client')
                    .get();
                
                if (!configSnapshot.exists) {
                    throw new Error('Client config document does not exist');
                }
                
                client = configSnapshot.data();
                logger.log('Client config loaded:', client);
            } catch (firestoreError) {
                logger.error('Firestore error:', firestoreError);
                
                // If it's an auth error, try to provide a fallback or better error message
                if (firestoreError.code === 'permission-denied') {
                    throw new Error('Access denied. Please check your authentication or contact support.');
                } else if (firestoreError.code === 'unavailable') {
                    throw new Error('Service temporarily unavailable. Please try again later.');
                } else {
                    throw new Error(`Failed to load client configuration: ${firestoreError.message}`);
                }
            }
        }
        return client;
    } catch (error) {
        logger.error('Error getting client config:', error);
        throw error;
    }
};

export const getClientId = async () => {
    const config = await getClientConfig();
    logger.log('client config: ', config);
    return config.client_id;
};

export const getClientName = async () => {
    const config = await getClientConfig();
    return config.client_name;
};

export const getClientBundleAppName = async () => {
    const config = await getClientConfig();
    return config.bundle_app_name;
};

export const getActivationDataURL = async () => {
    const config = await getClientConfig();
    return config.activation_data_url;
};

export const getCompleteActivationURL = async () => {
    const config = await getClientConfig();
    return config.complete_activation_url;
};

export const getAppCollectionName = async (examKey) => {
    try {
        const exams = await getClientExams();
        const exam = exams.find(exam => exam.key === examKey);
        return exam ? exam.appCollectionName : "CISSP";
    } catch (error) {
        logger.error('Error getting app collection name:', error);
        return "CISSP";
    }
};

export const getIOSURL = async () => {
    const config = await getClientConfig();
    return config.ios_url;
};

export const getAndroidURL = async () => {
    const config = await getClientConfig();
    return config.android_url;
};

